export const AudioUrl = 'https://gentest.valetez.com/swiftly.mp3';
